// extracted by css-extract-rspack-plugin
export default {"plasmicQueryBuilderScope":"src-wab-client-components-QueryBuilder-QueryBuilder-module__plasmicQueryBuilderScope-iL55rn"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"plasmicQueryBuilderScope\":\"src-wab-client-components-QueryBuilder-QueryBuilder-module__plasmicQueryBuilderScope-iL55rn\"}";
        // 1793541994362
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  